import { render } from "./SelectChanelWidget.vue?vue&type=template&id=247680ce&scoped=true&ts=true"
import script from "./SelectChanelWidget.vue?vue&type=script&lang=ts"
export * from "./SelectChanelWidget.vue?vue&type=script&lang=ts"

import "./SelectChanelWidget.vue?vue&type=style&index=0&id=247680ce&scoped=true&lang=scss"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247680ce"]])

export default __exports__